(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8455],{

/***/ 6008:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact-us",
      function () {
        return __webpack_require__(7447);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9881:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);


const BreadCrumbSchema = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
            type: "application/ld+json",
            dangerouslySetInnerHTML: {
                __html: JSON.stringify({
                    "@context": "https://schema.org/",
                    "@type": "BreadcrumbList",
                    "itemListElement": [
                        {
                            "@type": "ListItem",
                            "position": 1,
                            "name": "About Us",
                            "item": "https://www.hoteltwintowers.com/about-us"
                        },
                        {
                            "@type": "ListItem",
                            "position": 2,
                            "name": "Room and Suits",
                            "item": "https://www.hoteltwintowers.com/hotel-room-in-shimla"
                        },
                        {
                            "@type": "ListItem",
                            "position": 3,
                            "name": "Bar and Restaurant",
                            "item": "https://www.hoteltwintowers.com/bar-and-restaurant"
                        },
                        {
                            "@type": "ListItem",
                            "position": 4,
                            "name": "Events",
                            "item": "https://www.hoteltwintowers.com/#events"
                        },
                        {
                            "@type": "ListItem",
                            "position": 5,
                            "name": "Banquet Halls in Shimla",
                            "item": "https://www.hoteltwintowers.com/banquet-halls-in-shimla"
                        },
                        {
                            "@type": "ListItem",
                            "position": 6,
                            "name": "Conference Halls",
                            "item": "https://www.hoteltwintowers.com/conference-hall"
                        }
                    ]
                })
            }
        })
    });
/* harmony default export */ __webpack_exports__["Z"] = (BreadCrumbSchema);


/***/ }),

/***/ 6240:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Topbanner; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _Topbanner_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9262);
/* harmony import */ var _Topbanner_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_Topbanner_module_scss__WEBPACK_IMPORTED_MODULE_1__);


function Topbanner(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
            className: (_Topbanner_module_scss__WEBPACK_IMPORTED_MODULE_1___default().top_banner),
            style: {
                backgroundImage: "url(".concat(props.bgImage, ")")
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_Topbanner_module_scss__WEBPACK_IMPORTED_MODULE_1___default().banner_text),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "container common_title text-center",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                        children: props.title
                    })
                })
            })
        })
    });
}


/***/ }),

/***/ 7447:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ contact_us; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/legacy/image.js
var legacy_image = __webpack_require__(9755);
var image_default = /*#__PURE__*/__webpack_require__.n(legacy_image);
// EXTERNAL MODULE: ./src/styles/pages/Contactus.module.scss
var Contactus_module = __webpack_require__(4566);
var Contactus_module_default = /*#__PURE__*/__webpack_require__.n(Contactus_module);
// EXTERNAL MODULE: ./node_modules/react-icons/fa/index.esm.js
var index_esm = __webpack_require__(9583);
// EXTERNAL MODULE: ./src/components/Topbanner/Topbanner.js
var Topbanner = __webpack_require__(6240);
;// CONCATENATED MODULE: ./src/hooks/useContactForm.js

const useContactForm = ()=>{
    const [values, setValues] = (0,react.useState)({
        fullname: "",
        email: "",
        phoneno: "",
        subject: "",
        message: ""
    });
    const handleChange = (e)=>{
        setValues((prevState)=>{
            return {
                ...prevState,
                [e.target.id]: e.target.value
            };
        });
    };
    return {
        values,
        handleChange
    };
};
/* harmony default export */ var hooks_useContactForm = (useContactForm);

// EXTERNAL MODULE: ./node_modules/axios/index.js + 40 modules
var axios = __webpack_require__(196);
;// CONCATENATED MODULE: ./src/lib/sendEmail.js

const sendEmail = async (fullname, email, phoneno, subject, message)=>{
    return (0,axios/* default */.ZP)({
        method: "post",
        url: "/api/send-mail",
        data: {
            fullname: fullname,
            email: email,
            phoneno: phoneno,
            subject: subject,
            message: message
        }
    });
};
/* harmony default export */ var lib_sendEmail = (sendEmail);

;// CONCATENATED MODULE: ./src/components/Contactusform/Contactusform.js



let Alert = (param)=>{
    let { message , type ="success"  } = param;
    return /*#__PURE__*/ _jsx("div", {
        style: {
            display: "block",
            width: "100%",
            background: type === "success" ? "rgba(0, 255, 0, 0.2)" : "rgba(255, 0, 0, 0.2)",
            color: "black",
            padding: "1rem",
            margin: "0.5rem",
            borderRadius: "10px",
            boxShadow: "0px 4px 10px rgba(0,0,0,0.1)"
        },
        children: message ? message : "The World Needs more `Lerts"
    });
};
const Contactusform = ()=>{
    const [contactName, setContactName] = useState("");
    const [contactEmail, setContactEmail] = useState("");
    const [contactPhone, setContactPhone] = useState("");
    const [contactSource, setContactSource] = useState("Twin Towers Website");
    const [contactEnquiry, setContactEnquiry] = useState("General Query");
    const [contactToken, setContactToken] = useState("r!AWs1gRgQQS?P4LKB/XMfXeN3T8XHjxrCJxJLDwwTKBxLluLRpdkigSGOWJo9QG");
    const [contactSubject, setContactSubject] = useState("");
    const [contactMessage, setContactMessage] = useState("");
    const [alertBanner, setAlertBanner] = useState(null);
    function handleForm(e) {
        e.preventDefault();
        // if (honey.length >= 1) {
        //     return
        // }
        let body = {
            name: contactName,
            email: contactEmail,
            phone: contactPhone,
            source: contactSource,
            enquiryType: contactEnquiry,
            subject: contactSubject,
            message: contactMessage,
            token: contactToken
        };
        fetch("".concat(location.origin, "/api/contactus"), {
            method: "POST",
            body: JSON.stringify(body)
        }).then((response1)=>{
            if (response1.status >= 300) {
                setAlertBanner({
                    message: response1.statusText,
                    type: "error"
                });
                return;
            }
            setAlertBanner({
                message: response1.statusText,
                type: "success"
            });
            console.debug("response");
            console.debug(response1);
        }).catch((error)=>{
            setAlertBanner({
                message: response.statusText,
                type: "error"
            });
            console.debug("error");
            console.error(error);
        });
    }
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsxs("form", {
            className: "".concat(styles.contact_from, " row"),
            onSubmit: handleForm,
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "col-md-6",
                    children: /*#__PURE__*/ _jsx("input", {
                        id: "name",
                        type: "text",
                        name: "name",
                        onChange: (e)=>setContactName(e.target.value),
                        value: contactName,
                        required: true,
                        className: styles.form_control,
                        placeholder: "Full Name"
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "col-md-6",
                    children: /*#__PURE__*/ _jsx("input", {
                        id: "email",
                        name: "email",
                        type: "email",
                        onChange: (e)=>setContactEmail(e.target.value),
                        value: contactEmail,
                        required: true,
                        className: styles.form_control,
                        placeholder: "Email"
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "col-md-6",
                    children: /*#__PURE__*/ _jsx("input", {
                        id: "phone",
                        required: true,
                        name: "phone",
                        type: "number",
                        onChange: (e)=>setContactPhone(e.target.value),
                        value: contactPhone,
                        className: styles.form_control,
                        placeholder: "Phone No"
                    })
                }),
                /*#__PURE__*/ _jsx("input", {
                    id: "source",
                    required: true,
                    name: "source",
                    type: "hidden",
                    value: contactSource,
                    className: "form-control"
                }),
                /*#__PURE__*/ _jsx("input", {
                    id: "enquiryType",
                    required: true,
                    name: "enquiryType",
                    type: "hidden",
                    value: contactEnquiry,
                    className: "form-control"
                }),
                /*#__PURE__*/ _jsx("input", {
                    id: "token",
                    required: true,
                    name: "token",
                    type: "hidden",
                    value: contactToken,
                    className: "form-control"
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "col-md-6",
                    children: /*#__PURE__*/ _jsx("input", {
                        id: "subject",
                        name: "subject",
                        onChange: (e)=>setContactSubject(e.target.value),
                        value: contactSubject,
                        required: true,
                        className: styles.form_control,
                        placeholder: "Subject"
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "pb-2",
                    children: /*#__PURE__*/ _jsx("textarea", {
                        id: "message",
                        name: "message",
                        onChange: (e)=>setContactMessage(e.target.value),
                        value: contactMessage,
                        required: true,
                        className: styles.from_textarea,
                        rows: "4",
                        placeholder: "Message"
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "".concat(styles.submit_btn, " col-md-6 col-sm-12"),
                    children: /*#__PURE__*/ _jsx("button", {
                        htmlFor: "contactUsForm",
                        type: "submit",
                        className: "common_btn",
                        children: "Submit"
                    })
                }),
                alertBanner !== null ? /*#__PURE__*/ _jsx(Alert, {
                    ...alertBanner
                }) : null
            ]
        })
    });
};
/* harmony default export */ var Contactusform_Contactusform = ((/* unused pure expression or super */ null && (Contactusform)));

// EXTERNAL MODULE: ./src/components/Schema/HotelSchema/breadcrumb.js
var breadcrumb = __webpack_require__(9881);
;// CONCATENATED MODULE: ./src/pages/contact-us.js












const Contactus = ()=>{
    const { values , handleChange  } = hooks_useContactForm();
    const [responseMessage, setResponseMessage] = (0,react.useState)({
        isSuccessful: false,
        message: ""
    });
    const handleSubmit = async (e)=>{
        e.preventDefault();
        setTimeout(()=>{
            setResponseMessage({
                isSuccessful: true
            });
        }, 3000);
        try {
            const req = await lib_sendEmail(values.fullname, values.email, values.phoneno, values.subject, values.message);
            if (req.status === 250) {
                setResponseMessage({
                    isSuccessful: true,
                    message: "Thank you for your message."
                });
                alert("Thank you for your message.");
            }
        } catch (e1) {
            setResponseMessage({
                isSuccessful: false,
                message: "Oops something went wrong. Please try again."
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "Book Hotel in Kufri | The Twin Towers Hotel in Shimla"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "The Twin Towers Hotel in Shimla-Get In Touch with The Twin Towers Hotel and Book hotel rooms in Kufri | The Twin Towers Hotel"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "icon",
                        href: "/favicon.svg"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: "https://www.hoteltwintowers.com/contact-us"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Topbanner/* default */.Z, {
                bgImage: "/images/contact-banner.png",
                title: "Contact Us"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: "".concat((Contactus_module_default()).contactus, " common_padding pb-0"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "row",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "".concat((Contactus_module_default()).contact_left, " col-md-4 common_title"),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            children: " Get In Touch"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "If you want to learn more about our services, contact us through this form or call us at"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (Contactus_module_default()).contect_info,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: "/icons/call-black.svg",
                                                    width: 36,
                                                    height: 36,
                                                    className: (Contactus_module_default()).footer_icon,
                                                    alt: "Reservation icon"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                            children: "Reservation"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: "tel:9318192605",
                                                            children: "+91 93181-92605"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: "tel:9317192601",
                                                            children: "+91 93171-92601"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: "tel:9318192601",
                                                            children: "+91 93181-92601"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (Contactus_module_default()).contect_info,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: "/icons/mail-black.svg",
                                                    width: 36,
                                                    height: 36,
                                                    className: (Contactus_module_default()).footer_icon,
                                                    alt: "Email Icon"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                            children: "email"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: "mailto:info@hoteltwintowers.com",
                                                            children: "info@hoteltwintowers.com"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (Contactus_module_default()).contect_info,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: "/icons/map-black.svg",
                                                    width: 40,
                                                    height: 36,
                                                    className: (Contactus_module_default()).footer_icon,
                                                    alt: "Map icon"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                            children: "Address"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: "https://g.page/hotel-the-twin-towers-new-kufri",
                                                            children: "NH 05, New kufri, Galu, Hills, Shimla, Himachal Pradesh, India 171209"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (Contactus_module_default()).contact_social_links,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (Contactus_module_default()).icon,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        className: (Contactus_module_default()).fb,
                                                        href: "https://www.facebook.com/twintower.hotel",
                                                        target: "_blank",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaFacebookF */.tBk, {})
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (Contactus_module_default()).icon,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: "https://www.instagram.com/hotel_twintowers",
                                                        className: (Contactus_module_default()).insta,
                                                        target: "_blank",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaInstagram */.Zf_, {})
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (Contactus_module_default()).icon,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        className: (Contactus_module_default()).linkedin,
                                                        href: "https://www.linkedin.com/in/the-twin-towers-hotel",
                                                        target: "_blank",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaLinkedinIn */.BUd, {})
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (Contactus_module_default()).icon,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        className: (Contactus_module_default()).linkedin,
                                                        href: "https://www.youtube.com/@thetwintowershotel",
                                                        target: "_blank",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaYoutube */.V2E, {})
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "".concat((Contactus_module_default()).contact_right, " col-md-8 common_title"),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            children: " Send A Message "
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                                            className: "row",
                                            onSubmit: handleSubmit,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "col-md-6",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        id: "fullname",
                                                        type: "text",
                                                        name: "fullname",
                                                        onChange: handleChange,
                                                        value: values.fullname,
                                                        required: true,
                                                        className: (Contactus_module_default()).form_control,
                                                        placeholder: "Full Name"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "col-md-6",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        id: "email",
                                                        type: "email",
                                                        name: "email",
                                                        value: values.email,
                                                        onChange: handleChange,
                                                        required: true,
                                                        className: (Contactus_module_default()).form_control,
                                                        placeholder: "Email"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "col-md-6",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        type: "number",
                                                        name: "phoneno",
                                                        value: values.phoneno,
                                                        onChange: handleChange,
                                                        required: true,
                                                        className: (Contactus_module_default()).form_control,
                                                        id: "phoneno",
                                                        placeholder: "Phone"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "col-md-6",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        id: "subject",
                                                        type: "text",
                                                        name: "subject",
                                                        value: values.subject,
                                                        onChange: handleChange,
                                                        required: true,
                                                        className: (Contactus_module_default()).form_control,
                                                        placeholder: "Subject"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "pb-2",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                                                        id: "message",
                                                        name: "message",
                                                        value: values.message,
                                                        onChange: handleChange,
                                                        required: true,
                                                        className: (Contactus_module_default()).from_textarea,
                                                        rows: "4",
                                                        placeholder: "Message"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "".concat((Contactus_module_default()).submit_btn, " col-md-6 col-sm-12"),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                        type: "submit",
                                                        className: "common_btn",
                                                        children: " Submit"
                                                    })
                                                }),
                                                responseMessage.isSuccessful === true ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: " success",
                                                    children: "We appreciate you contacting us. One of our customer happiness members will be getting back to you shortly."
                                                }) : ""
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "pt-5",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                            src: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d13666.806624298124!2d77.2852872!3d31.0902248!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390583ff77109ab1%3A0xb1b39c68310de225!2sThe%20Twin%20Towers%20Hotel%20New%20Kufri!5e0!3m2!1sen!2sin!4v1668662868345!5m2!1sen!2sin",
                            width: "100%",
                            height: "450",
                            allowFullScreen: "",
                            loading: "lazy",
                            referrerPolicy: "no-referrer-when-downgrade"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(breadcrumb/* default */.Z, {})
        ]
    });
};
/* harmony default export */ var contact_us = (Contactus);


/***/ }),

/***/ 9262:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"top_banner":"Topbanner_top_banner__iVW4z","banner_text":"Topbanner_banner_text__wm4dg"};

/***/ }),

/***/ 4566:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"contactus":"Contactus_contactus__oZnag","contact_left":"Contactus_contact_left__1CGMU","contect_info":"Contactus_contect_info__DmRTk","contact_text":"Contactus_contact_text___Afjl","contact_social_links":"Contactus_contact_social_links__K3LwM","icon":"Contactus_icon__J8Kgs","contact_right":"Contactus_contact_right__Gg62t","form_control":"Contactus_form_control__nJclK","enquire_textarea":"Contactus_enquire_textarea__xgECa","from_textarea":"Contactus_from_textarea__tKDba","submit_btn":"Contactus_submit_btn__jurFg","enquire_submit_btn":"Contactus_enquire_submit_btn__DyE67"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [196,9774,2888,179], function() { return __webpack_exec__(6008); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);